import { render, staticRenderFns } from "./basicInfo.vue?vue&type=template&id=925aaccc&scoped=true"
import script from "./basicInfo.vue?vue&type=script&lang=js"
export * from "./basicInfo.vue?vue&type=script&lang=js"
import style0 from "./basicInfo.vue?vue&type=style&index=0&id=925aaccc&prod&lang=scss&scoped=true"
import style1 from "./basicInfo.vue?vue&type=style&index=1&id=925aaccc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "925aaccc",
  null
  
)

export default component.exports